const AVAILABLE_METRICS = {
  LOADED_EMPTY_FILTER: 'LOADED_EMPTY_FILTER',
  BT_FILTER_CLICK: 'BT_FILTER_CLICK',
  ITEM_CLICK: 'ITEM_CLICK',
  ITEM_TOP_POSITION_CLICK: 'ITEM_TOP_POSITION_CLICK',
  ITEM_SECOND_RANGE_CLICK: 'ITEM_SECOND_RANGE_CLICK',
  ITEM_THIRD_RANGE_CLICK: 'ITEM_THIRD_RANGE_CLICK',
  ITEM_FOURTH_RANGE_CLICK: 'ITEM_FOURTH_RANGE_CLICK',
  VENDOR_SECOND_RANGE_CLICK: 'VENDOR_SECOND_RANGE_CLICK',
  VENDOR_THIRD_RANGE_CLICK: 'VENDOR_THIRD_RANGE_CLICK',
  VENDOR_FOURTH_RANGE_CLICK: 'VENDOR_FOURTH_RANGE_CLICK',
  DELIVERY_TIME_FILTER_CLICK: 'DELIVERY_TIME_FILTER_CLICK',
  DISTANCE_FILTER_CLICK: 'DISTANCE_FILTER_CLICK',
  RANKING_FILTER_CLICK: 'RANKING_FILTER_CLICK',
  TERMS_AND_CONDITIONS_CLICK: 'TERMS_AND_CONDITIONS_CLICK',
  BACK_BUTTON_CLICK: 'BACK_BUTTON_CLICK',
  VENDOR_CLICK: 'VENDOR_CLICK',
  VENDOR_TOP_POSITION_CLICK: 'VENDOR_TOP_POSITION_CLICK',
  LOADED_EMPTY_STATE: 'LOADED_EMPTY_STATE',
  SERVER_ERROR: 'SERVER_ERROR',
  CLIENT_ERROR: 'CLIENT_ERROR',
  LOADED_EMPTY_ITEM: 'LOADED_EMPTY_ITEM',
  LOADED_ERROR_ITEM: 'LOADED_ERROR_ITEM',
};

module.exports = { AVAILABLE_METRICS };
